const Delivery = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="shipping">
        <g id="Group">
          <path
            id="Vector"
            d="M40.7812 37.9688H37.9688V18.2812C37.9688 17.5046 37.3392 16.875 36.5625 16.875H28.8281H21.7969H15.4688V6.32812C15.4688 4.63869 14.8107 3.04963 13.615 1.85282C12.419 0.658037 10.83 0 9.14062 0C5.65128 0 2.8125 2.83878 2.8125 6.32812C2.8125 7.10473 3.44206 7.73438 4.21875 7.73438C4.99544 7.73438 5.625 7.10473 5.625 6.32812C5.625 4.38961 7.20211 2.8125 9.14062 2.8125C10.0793 2.8125 10.9623 3.1783 11.6262 3.84152C12.2904 4.50633 12.6562 5.38945 12.6562 6.32812V18.2812V33.928C10.2328 34.554 8.4375 36.7588 8.4375 39.375C8.4375 42.4767 10.9608 45 14.0625 45C16.6787 45 18.8835 43.2047 19.5095 40.7812H36.5625H40.7812C41.5579 40.7812 42.1875 40.1516 42.1875 39.375C42.1875 38.5984 41.5579 37.9688 40.7812 37.9688ZM27.4219 19.6875V22.5H23.2031V19.6875H27.4219ZM14.0625 42.1875C12.5117 42.1875 11.25 40.9258 11.25 39.375C11.25 37.8242 12.5117 36.5625 14.0625 36.5625C15.6133 36.5625 16.875 37.8242 16.875 39.375C16.875 40.9258 15.6133 42.1875 14.0625 42.1875ZM19.5095 37.9688C18.9997 35.995 17.4425 34.4378 15.4688 33.928V19.6875H20.3906V23.9062C20.3906 24.6829 21.0202 25.3125 21.7969 25.3125H28.8281C29.6048 25.3125 30.2344 24.6829 30.2344 23.9062V19.6875H35.1562V37.9688H19.5095Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};

export default Delivery;
